import Box from '@mui/system/Box'
import Icon from '@mui/material/Icon'
import Typography from '@mui/material/Typography'
import { useNavigate } from 'react-router-dom'

// components
import AdxTableBottomCTA from 'components/reusable/table/AdxTableBottomCTA'
import PendingReportsList from './lists/PendingReportsList'
import { useQuery } from 'react-query'
import { ReportIconConstructor } from 'module/claim/pages/report/functions'
import { getQueryReports } from 'services/api/modules/claim/report'
import EmptyData from 'module/leave/pages/createRequest/components/emptyData'
import ClaimLoadingState from './ClaimLoadingState'
import AdxEmptyStateV2 from 'components/reusable/emptyState/AdxEmptyStateV2'

const PendingApproverReportPanel = () => {
  // micro component
  const ViewAllWaitingApprovalButton = () => {
    const navigate = useNavigate()
    return (
      <Typography
        variant="body1"
        color="alternate.main"
        sx={{ textDecoration: 'underline', cursor: 'pointer' }}
        onClick={() =>
          navigate(`../claim/reports`, {
            state: { fromDashboard: true, initialTabsValue: 1 },
          })
        }
      >
        View All
      </Typography>
    )
  }

  // react query hook
  const { data: pendingApproverReportData, isLoading } = useQuery(
    'pendingApproverReportsData',
    async () => {
      const { data } = await getQueryReports({ status: 'pending approver' })
      return data?.reports
    }
  )

  if (isLoading) {
    return <ClaimLoadingState />
  }

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, pt: 2, bgcolor: 'white.main' }}>
      <Box
        height={95}
        bgcolor="alternate.light"
        borderRadius="4.5px"
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        paddingX={3}
        mx={2}
      >
        <Box display="flex" alignItems={'center'} columnGap={2.5}>
          <Icon sx={{ fontSize: 40, color: 'alternate.main' }}>account_balance_wallet_rounded</Icon>
          <Box>
            <Typography variant="body1" color="light-gray-text.main">
              Total pending
            </Typography>
            <Typography variant="body2" color="dark-text.main">
              Total claims to be reimbursed
            </Typography>
          </Box>
        </Box>
        <Box>
          {pendingApproverReportData && (
            <Typography variant="h4" color="alternate.main" fontWeight="bold">
              RM{' '}
              {parseFloat(
                pendingApproverReportData
                  ?.map((item) => item.amount_total)
                  .reduce((a, b) => a + b, 0)
              ).toFixed(2)}
            </Typography>
          )}
        </Box>
      </Box>
      <AdxTableBottomCTA
        bottomCTA={<ViewAllWaitingApprovalButton />}
        emptyStateComponent={
          <AdxEmptyStateV2 icon={<Icon>article</Icon>} title="No reports awaiting approval" />
        }
      >
        {pendingApproverReportData?.slice(0, 7).map((list, index) => (
          <PendingReportsList
            key={index}
            reportID={list.id}
            reportType={list.claim_report_type}
            reportName={list.title}
            muiIcon={ReportIconConstructor(list.claim_report_type)}
            startDate={list.start_date}
            endDate={list.end_date}
            totalAmount={list.amount_total}
          />
        ))}
      </AdxTableBottomCTA>
    </Box>
  )
}

export default PendingApproverReportPanel
